import AutomatedMarketingPageConfig from '../apps/automatedMarketing/AutomatedMarketingPageConfig';
import CampaignPageConfig from '../apps/communicationCampaign/CampaignPageConfig';
import CrmClientsAppConfig from '../apps/crm/CrmClientsAppConfig';
import EMarketingAppConfig from '../apps/eMarketing/EMarketingAppConfig';
import FormsAppConfig from '../apps/forms/FormsAppConfig';
import FranchisesAppConfig from '../apps/franchises/FranchisesPageConfig';
import GamesAppConfig from '../apps/games/GamesAppConfig';
import GoogleReviewsPageConfig from '../apps/googleReviews/GoogleReviewsPageConfig';
import LoyaltyPageConfig from '../apps/loyalties/LoyaltyPageConfig';
import PronoAppConfig from '../apps/prono/PronoAppConfig';
import ReferralAppConfig from '../apps/referral/ReferralAppConfig';
import SatisfactionPageConfig from '../apps/satisfaction/SatisfactionPageConfig';
import TabletPageConfig from '../apps/tablet/TabletPageConfig';
import VisibilityAppConfig from '../apps/visibility/VisibilityAppConfig';
import ForbiddenPageConfig from './auth/forbidden/ForbiddenPageConfig';
import ForgotPasswordPageConfig from './auth/forgot-password/ForgotPasswordPageConfig';
import LockPageConfig from './auth/lock/LockPageConfig';
import ResetPasswordPageConfig from './auth/reset-password/ResetPasswordPageConfig';
import ClientsAppConfig from './clients/ClientsAppConfig';
import ComingSoonPageConfig from './coming-soon/ComingSoonPageConfig';
import Error404PageConfig from './errors/404/Error404PageConfig';
import Error500PageConfig from './errors/500/Error500PageConfig';
import KnowledgeBasePageConfig from './knowledge-base/KnowledgeBaseConfig';
import MaintenancePageConfig from './maintenance/MaintenancePageConfig';
import ProfilePageConfig from './profile/ProfilePageConfig';
import ClassicSearchPageConfig from './search/classic/ClassicSearchPageConfig';
import ModernSearchPageConfig from './search/modern/ModernSearchPageConfig';
import StorePageConfig from './stores/StorePageConfig';

const pagesConfigs = [
  ClassicSearchPageConfig,
  ComingSoonPageConfig,
  Error404PageConfig,
  Error500PageConfig,
  ForgotPasswordPageConfig,
  KnowledgeBasePageConfig,
  LockPageConfig,
  LoyaltyPageConfig,
  MaintenancePageConfig,
  ModernSearchPageConfig,
  ProfilePageConfig,
  ResetPasswordPageConfig,
  StorePageConfig,
  ClientsAppConfig,
  FranchisesAppConfig,
  GoogleReviewsPageConfig,
];

const paidPagesConfigs = [
  CampaignPageConfig,
  CrmClientsAppConfig,
  EMarketingAppConfig,
  TabletPageConfig,
  SatisfactionPageConfig,
  AutomatedMarketingPageConfig,
  GamesAppConfig,
  PronoAppConfig,
  ReferralAppConfig,
  VisibilityAppConfig,
  FormsAppConfig,
];

export { pagesConfigs, paidPagesConfigs, ForbiddenPageConfig };
